import { render } from "./NewsBanner.vue?vue&type=template&id=579720d9&scoped=true"
import script from "./NewsBanner.vue?vue&type=script&defer=true&lang=js"
export * from "./NewsBanner.vue?vue&type=script&defer=true&lang=js"

import "./NewsBanner.vue?vue&type=style&index=0&id=579720d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579720d9"]])

export default __exports__